import { ccwpApi } from "@/services";

export const PaymentStatusApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentStatusList: builder.query<any, any>({
      query: (args) => {
        return {
          url: `Payment/GetPaymentRecordsList`,
          method: "GET",
          params: { ...args },
        };
      },
    }),
    updatePaymentStatus: builder.mutation({
      query: (statusData) => ({
        url: "Payment/UpdatePaymentStatus",
        method: "POST",
        body: statusData,
      }),
    }),
    getPaymentFilter: builder.query({
      query: ({
        CaseId,
        PayeeName,
        AccountName,
        Prefix,
        PaymentReferenceStartWith,
        PaymentReferenceEndWith,
        StartDate,
        EndDate,
        LowerBound,
        upperBound,
        PostedDateStart,
        PostedDateEnd,
        PaymentStatus,
        PageNumber,
        PageSize,
        SearchText,
        SortColumn,
        SortOrder,
        statusUpdateStartDate,
        statusUpdateEndDate,
      }) => ({
        url: "Payment/GetPaymentFilterList",
        method: "GET",
        params: {
          CaseId,
          PayeeName,
          AccountName,
          Prefix,
          PaymentReferenceStartWith,
          PaymentReferenceEndWith,
          StartDate,
          EndDate,
          LowerBound,
          upperBound,
          PostedDateStart,
          PostedDateEnd,
          PaymentStatus,
          PageNumber,
          PageSize,
          SearchText,
          SortColumn,
          SortOrder,
          statusUpdateStartDate,
          statusUpdateEndDate,
        },
      }),
    }),
    deletePayment: builder.query({
      query: (id) => ({
        url: `Payment/DeletePayment?paymentId=${id}`,
        method: "DELETE",
      }),
    }),
    updateBulkPaymentStatus: builder.mutation({
      query: (bulkStatusData) => ({
        url: "Payment/BulkUpdatePaymentStatus",
        method: "POST",
        body: bulkStatusData,
      }),
    }),
    getPaymentSettlementList: builder.query<any, any>({
      query: (args) => {
        return {
          url: `Payment/SettlementListByPayment`,
          method: "GET",
          params: { ...args },
        };
      },
    }),
    getPaymentSummary: builder.query<any, string>({
      query: (paymentId) => {
        return {
          url: `Payment/paymentSummary?paymentId=${paymentId}`,
        };
      },
    }),
    getSubAccounts: builder.query<any, string | undefined>({
      query: (caseId) => {
        return {
          url: `Payment/GetSubAccounts?caseId=${caseId}`,
        };
      },
    }),
    getManualPaymentClaimItems: builder.query<any, any>({
      query: (data) => {
        const { claimItemIds, ...rest } = data;
        const params = { ...rest };
        if (claimItemIds && claimItemIds.length > 0) {
          claimItemIds.forEach((id: string, index: number) => {
            params[`claimItemIds[${index}]`] = id;
          });
        }
        return {
          url: `Payment/GetManualPaymentClaimItems`,
          method: "GET",
          params,
        };
      },
    }),
    generateManualPayment: builder.mutation({
      query: (paymentData) => ({
        url: "Payment/GenerateManualPayment",
        method: "POST",
        body: paymentData,
      }),
    }),
    getPendingTransactions: builder.query<any, any>({
      query: (args) => {
        return {
          url: "Payment/GetPendingBankTransactions",
          params: { ...args },
        };
      },
    }),
    resolvePendingTransactions: builder.mutation({
      query: (transactionData) => ({
        url: "Payment/ResolvePendingTransactions",
        method: "DELETE",
        body: transactionData,
      }),
    }),
  }),
});

export const {
  useGetPaymentStatusListQuery,
  useUpdatePaymentStatusMutation,
  useLazyGetPaymentFilterQuery,
  useLazyDeletePaymentQuery,
  useUpdateBulkPaymentStatusMutation,
  useGetPaymentSettlementListQuery,
  useGetPaymentSummaryQuery,
  useGetSubAccountsQuery,
  useLazyGetManualPaymentClaimItemsQuery,
  useGenerateManualPaymentMutation,
  useGetPendingTransactionsQuery,
  useResolvePendingTransactionsMutation,
} = PaymentStatusApi;
